import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import EnumFormSelect from 'shared/components/formFields/EnumFormSelect';
import { PayType } from 'shared/models/PaySettings';
import { selectCustomFieldValuesByIds } from 'store/entities/customFields/selectors';

interface IPayTypeSelectProps {
    jobOrderId?: string | null;
    className?: string;
    disabled?: string;
    label?: string;
    name: string;
}

export const PayTypeSelect = ({ jobOrderId, ...props }: IPayTypeSelectProps) => {
    const customFieldValues = useSelector(selectCustomFieldValuesByIds);

    const options = useMemo(() => {
        const position = customFieldValues[jobOrderId || ''];
        const payTypeValues = Object.values(PayType);
        const positionPayType = position?.data?.pay_type || null;
        if (positionPayType) {
            return payTypeValues.filter(payType => payType === positionPayType);
        }
        return payTypeValues;
    }, [customFieldValues, jobOrderId]);

    return (
        <EnumFormSelect
            {...props}
            // @ts-ignore
            values={options}
            resetIfValueNotAvailable
            autoSelectSingleVariant
        />
    );
};
